import { render, staticRenderFns } from "./OneByOneComponentRenderer.vue?vue&type=template&id=327909c1&scoped=true&"
import script from "./OneByOneComponentRenderer.vue?vue&type=script&lang=ts&"
export * from "./OneByOneComponentRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327909c1",
  null
  
)

export default component.exports